import React from 'react'

import { LOCIZE_NAMESPACE } from 'main/common'
import { FormGroup } from 'main/components/common/Form'
import { colors, spacing, Text, TimeSelect } from 'main/ui'
import { useTranslation } from 'react-i18next'
import { i18nKeyPrefix } from '../i18n'
import Days from './Days'
import { IDays, IParams, IValidation } from './types'

const PRE = `${i18nKeyPrefix}-DESIRED-WEEKLY-SCHEDULE`

interface IProps {
  params: IParams
  validationHints: IValidation
  onChangeDays: (value: Partial<IDays>) => void
  onChangeDropoffAt: (value: string | null) => void
  onChangePickupAt: (value: string | null) => void
}

export default function DesiredWeeklyScheduleFields(props: IProps) {
  const { params, validationHints, onChangeDays, onChangeDropoffAt, onChangePickupAt } = props
  const { t } = useTranslation(LOCIZE_NAMESPACE)

  return (
    <div>
      <Days days={params.days} validationHint={validationHints.days} onChangeDays={onChangeDays} />

      <div css={{ marginTop: spacing.majorScale(3) }}>
        <FormGroup>
          <div>
            <TimeSelect
              label={t(`${PRE}-DROP-OFF`)}
              invalid={!!validationHints.dropoffAt}
              value={params.dropoffAt}
              onChange={onChangeDropoffAt}
            />
          </div>
          <div>
            <TimeSelect
              label={t(`${PRE}-PICK-UP`)}
              invalid={!!validationHints.pickupAt}
              value={params.pickupAt}
              onChange={onChangePickupAt}
            />
          </div>
        </FormGroup>

        {validationHints.times && (
          <div css={{ marginTop: spacing.majorScale(1) }}>
            <Text css={{ color: colors.text.error }}>{validationHints.times}</Text>
          </div>
        )}
      </div>
    </div>
  )
}
